<template>
  <main>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item
        :to="{ path: './visa_list', query: { id: info.spu_id, detailId: info.sku_id } }"
        >签证详情</el-breadcrumb-item> -->
      <el-breadcrumb-item>签证详情</el-breadcrumb-item>
      <el-breadcrumb-item>提交订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-steps :active="2" simple>
      <el-step title="提交订单" icon="el-icon-edit"></el-step>
      <el-step title="在线支付" icon="el-icon-connection"></el-step>
      <!-- <el-step title="上传资料" icon="el-icon-picture"></el-step> -->
      <el-step title="完成" icon="el-icon-chat-line-round"></el-step>
    </el-steps>
    <section class="order_info">
      <figure class="desc">
        <i class="icon-gou"></i>
        <p>
          <span>订单提交成功，请您尽快付款！ 订单号：<b>{{ info.order_sn }}</b></span>
          <span>请在<strong>2小时内</strong>完成订单支付， 否则订单会自动取消。</span>
        </p>
      </figure>
      <div class="price">
        <p><span>应付金额：</span><b>{{ info.order_price }}</b></p>
        <strong :class="{ open: showTable }" @click="showTable = !showTable">订单详情</strong>
      </div>
      <el-table :data="[info]" v-show="showTable">
        <el-table-column prop="spu_name" label="产品名称"></el-table-column>
        <el-table-column prop="sku_name" label="套餐名称"></el-table-column>
        <el-table-column align="center" prop="sku_travel_date" label="出行日期"></el-table-column>
        <el-table-column align="center" prop="sku_price" label="套餐价格"></el-table-column>
        <el-table-column align="center" prop="sku_quantity" label="购买数量"></el-table-column>
        <el-table-column align="center" prop="order_price" label="订单价格"></el-table-column>
        <el-table-column align="center" prop="extra_price" label="其他费用"></el-table-column>
      </el-table>
    </section>
    <!-- <div class="cancelOrderBtn">立即取消订单</div> -->
    <section class="pay">
      <h3>支付方式</h3>
      <label>
        <el-radio v-model="payType" :disabled="true" label="0">余额支付</el-radio>
        <el-radio v-model="payType" label="1">第三方支付</el-radio>
      </label>
      <ul class="user" v-show="payType === '0'">
        <li>
          <span>账户余额：</span><b>0.00元</b>
          <strong>余额不足，请先<router-link :to="{ path: './' }">充值</router-link></strong>
        </li>
        <li>
          <span>支付密码：</span>
          <el-input disabled="" type="password" size="small" v-model="test"></el-input>
          <strong>请先设置支付密码，<router-link :to="{ path: './' }">点击设置</router-link>跳至设置支付密码页面</strong>
        </li>
      </ul>
      <nav v-show="payType === '1'" class="otherPay">
        <a :class="{ on: payOption === 'zfb' }" @click="updatePayType"><img src="@assets/img/zhifubao.png" alt=""></a>
        <a :class="{ on: payOption === 'wx' }" @click="payOption = 'wx'"><img src="@assets/img/weixinzhifu.png"
            alt=""></a>
      </nav>
      <div class="qrcode" v-loading="loading" :class="{ pay_success: payState }">
        <vue-qrcode
          :value="`${payOption === 'wx' ? 'https://h5.cstravel.cn/api/v2/Yspay/wxJs?order_type=xorder&order_sn=' + info.order_sn : alipayUrl}`"
          :options="{ width: 200 }" />
        <p>手机扫码进行支付</p>
      </div>
    </section>
  </main>
</template>

<script>
import $visa from '@api/visa';
import VueQrcode from 'vue-qrcode'
import tool from '@assets/js/tool';
export default {
  components: {
    VueQrcode
  },
  data() {
    return {
      info: {},
      showTable: false,
      payType: '1',
      payOption: 'wx',
      alipayUrl: null,
      payState: false,
      loading: false, // 支付方式loading
      test: ''
    }
  },
  created() {
    const { order_sn } = this.$route.query;
    if (!order_sn) {
      this.$router.push('visa');
      return;
    }
    this.getDetail(order_sn);
    this.listenPayResult(order_sn);
  },
  methods: {
    // 返回正常显示的价格
    setNormalPrice(price) {
      return tool.ConversionPrice(price)
    },
    // 切换支付方式
    updatePayType() {
      const { payOption, info } = this;
      const { order_sn } = this.$route.query;
      if (payOption !== 'zfb') {
        this.loading = true;
        this.payOption = 'zfb';
        const alipayParam = {
          payment_type: 'YspayAlipay',
          order_type: 'xorder',
          order_sn: order_sn
        }
        $visa.getAliPayQrcode(alipayParam).then(res => {
          this.alipayUrl = res.source_qr_code_url + '?test=' + res.trade_no;
          this.loading = false;
        })
      }
    },
    // 通过订单号获取订单详情内容
    getDetail(order_sn) {
      $visa.getOrderDetailByOrdersn(order_sn).then(res => {
        res.data.order_price = tool.ConversionPrice(res.data.order_price);
        res.data.sku_price = tool.ConversionPrice(res.data.sku_price);

        res.data.extra_price = res.data.extra_price ? tool.ConversionOtherPrice(res.data.extra_price) : 0;
        this.info = res.data;
      });
    },
    // 监听订单是否已支付
    listenPayResult(order_sn) {
      if (this.$route.name !== 'order_payment') { return; }
      $visa.getOrderDetailByOrdersn(order_sn).then((res) => {
        const { payment_status } = res.data;
        if (payment_status != 'F') {
          setTimeout(() => {
            this.listenPayResult(order_sn);
          }, 2000);
        } else {
          this.$message.success('支付成功！');
          this.payState = true;
          setTimeout(() => {
            this.$router.push({ name: 'order_list' });
          }, 3000);
        }

      })
    }
  }
}
</script>

<style scoped src="./payment.css"></style>

<style>
@media only screen and (max-width: 768px) {

  .el-step.is-simple .el-step__title {
    font-size: 14px !important;
  }
}
</style>